var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTurnoverIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1865_2972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.74935 2.79225C5.06811 3.17557 3.59723 4.18758 2.63833 5.62077C1.67944 7.05395 1.30519 8.79969 1.59235 10.5M6.74935 2.79225L4.49935 1.875M6.74935 2.79225L5.99935 4.875M14.2974 12.375C14.7605 11.4429 15.0008 10.4159 14.9994 9.375C14.9994 6.03 12.5671 3.25425 9.37435 2.718M14.2974 12.375L16.4994 10.875M14.2974 12.375L13.1244 10.125M2.63635 13.125C3.25262 14.0485 4.08742 14.8056 5.06661 15.3289C6.0458 15.8523 7.13908 16.1257 8.24935 16.125C9.91011 16.1271 11.5129 15.5148 12.7494 14.406M2.63635 13.125H5.24935M2.63635 13.125V15.75",
    stroke: "#286F29",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1865_2972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnoverIcon);
export default __webpack_public_path__ + "static/media/turnoverIcon.3a8223c161348e1b99ef5646b7e1a019.svg";
export { ForwardRef as ReactComponent };